import { html } from 'lit';
const Yesterday =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.335 3.095c.38 0 .688.308.688.688v.688h5.963v-.688a.688.688 0 0 1 1.376 0v.688h2.065a2.523 2.523 0 0 1 2.522 2.523v5.504a.688.688 0 1 1-1.376 0v-2.43H4.437v7.934c0 .634.513 1.147 1.146 1.147h5.963a.688.688 0 0 1 0 1.376H5.583a2.523 2.523 0 0 1-2.522-2.523V6.994A2.523 2.523 0 0 1 5.583 4.47h2.064v-.688c0-.38.308-.688.688-.688m6.651 2.752v.688a.688.688 0 0 0 1.376 0v-.688h2.065c.633 0 1.146.514 1.146 1.147v1.514H4.437V6.994c0-.633.513-1.147 1.146-1.147h2.064v.688a.688.688 0 1 0 1.376 0v-.688zm1.68 9.834a.69.69 0 0 1 0 .973l-1.46 1.46 1.46 1.46a.688.688 0 1 1-.974.972L13.746 18.6a.69.69 0 0 1 0-.973l1.946-1.946a.69.69 0 0 1 .973 0m4.193.973a.688.688 0 1 0-.973-.973l-1.946 1.946a.69.69 0 0 0 0 .973l1.946 1.946a.688.688 0 1 0 .973-.973l-1.46-1.46z" clip-rule="evenodd"/>
  </svg>
`;
export default Yesterday;
